import { createAction, handleActions } from 'redux-actions';
import { fromJS } from 'immutable';
import { createSelector } from 'reselect';

export const startFileDownload = createAction('FILE_DOWNLOAD_START');
export const resetFileDownload = createAction('FILE_DOWNLOAD_RESET');

export const actions = {
  startFileDownload,
  resetFileDownload,
};

export const initialState = fromJS({
  actionPath: null,
  method: 'GET',
  queryParams: {},
});

export default handleActions({
  [startFileDownload]: (state, action) => {
    return state.merge(action.payload);
  },

  [resetFileDownload]: (state, action) => {
    return initialState;
  },
}, initialState);

const fileDownloadSelector = state => state.fileDownload;

export const getFileDownload = createSelector(
  fileDownloadSelector,
  data => data.toJS(),
);



// WEBPACK FOOTER //
// ./src/components/ui/FileDownload/reducer.js